import { UserRole } from "../global";
import { sessionRoleMatchesAllowList } from "../global/role-session";
import type { IActiveUserSession } from "../ports/outputs/session";
import { RBAC_PERMISSIONS } from "./rbac-permission-codes";
import { sessionHasPermission } from "./session-permissions";

export function canViewAiIncidentsFromSession(
  session: IActiveUserSession | null | undefined,
): boolean {
  if (!session) {
    return false;
  }
  if (sessionRoleMatchesAllowList(session.role, [UserRole.SuperAdministrator])) {
    return true;
  }
  return sessionHasPermission(session, RBAC_PERMISSIONS.AI_INCIDENTS_VIEW);
}
